export default __webpack_public_path__ + "static/media/linkedin.8b6a3045.svg";